import FreeMaterialDetailsSideBar from "@/features/pages/FreeMaterials/FreeMaterialDetails/FreeMaterialDetailsSideBar"
import { useFreeMaterialData } from "@/queries/queries/freeMaterialsQueries"
import { Outlet, useParams } from "react-router"

export default function FreeMaterialsDetails() {
  const { courseId } = useParams()
  const freeMaterialsQuery = useFreeMaterialData()

  const course = freeMaterialsQuery.data?.data.find(
    (course) => course.id === Number(courseId)
  )

  if (!course) return null

  return (
    <div
      style={{ backgroundColor: "#ebf1f8ff", minHeight: "100%" }}
      className="d-flex"
    >
      <FreeMaterialDetailsSideBar course={course} />
      <div className="ps-2 w-100 bg-light">
        <Outlet />
      </div>
    </div>
  )
}
